"use strict";

import {
    RetentionDeviceBackupModalComponent
} from "@nms-ng2/app/modules/device/device-backup/retention-device-backup-modal/retention-device-backup-modal.component";
import {
    AuditRetentionModalComponent
} from "@nms-ng2/app/shared/components/modals/audit-retention/audit-retention-modal.component";

/*
* @ngdoc controller
* @name nms:NavbarController
* @description
* Controller para itens de navbar. Esta controller contém componentes que podem ser acessados por todo o sistema.
*/
var app = angular.module("nms");
app.controller("NavbarController", ["$scope", "ModalFactory", "UserPreferencesService", "$translate",
    function ($scope, ModalFactory, UserPreferencesService, $translate) {

        $scope.tooltipVisible = false;
        $scope.updateVersionTooltipKey = "updateVersionTooltip";
        $scope.nmsUpdateAvailableTooltip = "";

        /**
         * Abre a modal de retenção de auditoria caso o usuário seja administrador, caso não seja,
         * essa opção nem será visualizada.
         */
        $scope.openAuditRetentionModal = function () {
            ModalFactory.openAsyncModal(AuditRetentionModalComponent, {});
        };

        /**
         * Abre a modal de retenção de backup de equipamentos caso o usuário seja administrador,
         * caso não seja, essa opção nem será visualizada.
         */
        $scope.openDcbRetentionModal = function () {
            ModalFactory.openAsyncModal(RetentionDeviceBackupModalComponent, {});
        };

        $scope.setNmsUpdateAvailableTooltip = () => {
            $scope.nmsUpdateAvailableTooltip =
                `<div class='tooltip-legend-wrapper'>
                    <div class='legend-title'>
                        <h4>${$translate.instant("nms-download-update-icon.tooltip.title")}</h4>
                    </div>
                    <p>${$translate.instant("nms-download-update-icon.nms-update.tooltip")}</p>
                </div>`;
        }

        $scope.closeTooltip = function() {
            $scope.tooltipVisible = false;
            const parametersList = { seen: true };
            UserPreferencesService.savePreferences(parametersList, $scope.updateVersionTooltipKey, ["seen"]);
            $scope.setNmsUpdateAvailableTooltip();
        };

        $scope.init = () => {
            const tooltipSeen =  UserPreferencesService.loadPreferences({}, $scope.updateVersionTooltipKey, ["seen"])
            $scope.tooltipVisible = !tooltipSeen.seen;

            if (!$scope.tooltipVisible) {
                $scope.setNmsUpdateAvailableTooltip();
            }
        }

        $scope.init();
    }]);
